import { render, staticRenderFns } from "./directdebit.vue?vue&type=template&id=2dbd3754"
import script from "./directdebit.vue?vue&type=script&lang=js"
export * from "./directdebit.vue?vue&type=script&lang=js"
import style0 from "./directdebit.vue?vue&type=style&index=0&id=2dbd3754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports